import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { trackSelectDealFromDealTable } from '../../utils/usageTracker';
import { getDealSplitAmountForDealRow, hasDealSplit } from '../../utils/deals';
import SubmitForecastBulkActionButton from './SubmitForecastBulkActionButton';
import SelectedDealAmountTotal from './SelectedDealAmountTotal';
import { getDealsArray, getShowSubmissionPanelFromDealTable, getSelectedDealAmount, getTotalDealAmount } from '../../selectors/dealsSelectors';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { getDealSplitsEnabled } from '../../selectors/portalSettings';
import { setSelectedDealAmount, setSelectedDealCount, setShowSubmissionPanelFromDealTable } from '../../actions/DealsActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BulkActions = ({
  querySelected,
  selection
}) => {
  const dispatch = useDispatch();
  const deals = useSelector(getDealsArray);
  const isDealStageView = useSelector(getIsDealStageView);
  const totalDealAmount = useSelector(getTotalDealAmount);
  const dealSplitsEnabled = useSelector(getDealSplitsEnabled);
  const isSubmissionPanelOpen = useSelector(getShowSubmissionPanelFromDealTable);
  const selectedDealAmountTotal = useSelector(getSelectedDealAmount);
  const selectedDeals = deals.filter(deal => selection.has(`${deal.dealId}`));
  useEffect(() => {
    // clean up selected deal count when bulk actions close
    return () => dispatch(setSelectedDealCount(0));
  }, [dispatch]);
  const handleClickSubmitForecastFromTable = useCallback(() => {
    if (!isSubmissionPanelOpen) {
      dispatch(setShowSubmissionPanelFromDealTable(true));
    }
  }, [dispatch, isSubmissionPanelOpen]);
  const dealsWithDealSplitsSelected = !!selectedDeals.find(deal => hasDealSplit(deal, !!dealSplitsEnabled));
  const manuallySelectedDealsTotal = selectedDeals.reduce((acc, deal) => {
    let amount = deal.dealAmount;
    // If property exists, check for deal split amount
    if (amount) {
      amount = getDealSplitAmountForDealRow(deal, dealSplitsEnabled, +amount);
    }
    return acc + amount || 0;
  }, 0);
  useEffect(() => {
    if (selectedDeals.length > 0) {
      trackSelectDealFromDealTable(isDealStageView);
    }
  }, [selectedDeals.length, isDealStageView]);
  useEffect(() => {
    if (totalDealAmount) {
      const total = querySelected ? totalDealAmount : {
        value: manuallySelectedDealsTotal,
        currencyCode: totalDealAmount.currencyCode
      };
      if (total && typeof total.value === 'number') {
        dispatch(setSelectedDealAmount(total));
        dispatch(setSelectedDealCount(selectedDeals.length));
      }
    }
  }, [querySelected, totalDealAmount, manuallySelectedDealsTotal, selectedDeals.length, dispatch]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    blockSize: "20px",
    children: [/*#__PURE__*/_jsx(SelectedDealAmountTotal, {
      dealsWithDealSplitsSelected: dealsWithDealSplitsSelected,
      totalToDisplay: selectedDealAmountTotal
    }), /*#__PURE__*/_jsx(SubmitForecastBulkActionButton, {
      isDealStageView: isDealStageView,
      onSubmitForecastFromTable: handleClickSubmitForecastFromTable
    })]
  });
};
export default BulkActions;